/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { getAuthorizationRolesUrl } from '@modules/cloud-api/v1/urls'

import { FETCH_AUTHZ_ROLES } from '@/constants/actions'

import asyncRequest from '../asyncRequests'

export function fetchAuthzRoles() {
  const url = getAuthorizationRolesUrl()

  return asyncRequest({
    type: FETCH_AUTHZ_ROLES,
    method: `GET`,
    url,
  })
}
